import { Box, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import styles from "../../styles";
import { ReactComponent as LeftArrowIcon } from "../../../../assets/svg/LeftArrowIcon.svg";
import { statusStyleArray } from "../../config";
import { getImageSrc } from "../../../../utils/CommonFunction";
import moment from "moment";
import VariantCarousel from "./VariantCarousel";
import { postFormData, getApiData } from "../../../../utils/APIHelper";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { Setting } from "../../../../utils/Setting";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

function InclusionDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id, inclusionId } = useParams();

  const { inclusionData, project } = location.state || {};
  const [loader, setLoader] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [details, setDetails] = useState([]);
  const [inclusionDetails, setInclusionDetails] = useState({});
  const [selectedBudget, setSelectedBudget] = useState(null);

  console.log("Inclusion Details:", inclusionData);
  console.log("Project Details:", project);

  useEffect(() => {
    if (inclusionData && project) {
      setInclusionDetails(inclusionData);
      // setSelectedBudget(inclusionData?.variants);
      setLoader(false);
    }
  }, [inclusionData, project]);

  useEffect(() => {
    console.log("id", id, inclusionId);
    getDetailsApiCall(id);
  }, [id]);

  async function getDetailsApiCall(packageId) {
    setLoader(true);
    try {
      const response = await getApiData(
        `api/v2/package/${packageId}`,
        "GET",
        {},
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        setDetails(response);
        const newMilestoneData = response?.inclusions?.find(
          (m) => m.id === Number(inclusionId)
        );
        console.log("---", newMilestoneData, inclusionId);
        if (newMilestoneData) {
          setInclusionDetails(newMilestoneData);

          if (selectedBudget && Object.keys(selectedBudget).length > 0) {
            const matchedVariant = newMilestoneData.variants.find(
              (variant) => variant.id === selectedBudget.id
            );
            console.log("matchedVariant", matchedVariant, selectedBudget);

            if (matchedVariant) {
              setSelectedBudget(matchedVariant);
            }
          }
        }
      }
    } catch (error) {
      console.error("API Fetch Error:", error);
    } finally {
      setLoader(false);
    }
  }

  const parsedInclusionDetails = React.useMemo(
    () => ({
      ...inclusionDetails,
      image: inclusionDetails?.image || {}, // Ensure image object exists
    }),
    [inclusionDetails]
  );

  console.log("parsedInclusionDetails", parsedInclusionDetails);
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file_1", file);
      formData.append("type", "package_boq");
      formData.append("tags", "");
      parsedInclusionDetails?.id &&
        formData.append("assign_id", parsedInclusionDetails?.id);

      try {
        const response = await postFormData(
          Setting.endpoints.packageFiles,
          formData
        );
        if (response?.success && response?.images?.length > 0) {
          getDetailsApiCall(parsedInclusionDetails?.packageId);
          toast.success("File uploaded successfully");
          // setInclusionDetails((prev) => ({
          //   ...prev,
          //   imageMetadata: response.images[0],
          // }));
        } else {
          toast.error("File upload failed");
        }
      } catch (error) {
        toast.error("An error occurred during file upload");
      }
    }
  };

  const handleDeleteImage = async () => {
    if (!parsedInclusionDetails?.image?.id) return;

    setButtonLoader(true);
    try {
      const response = await getApiData(
        `api/project/delete-files/${parsedInclusionDetails.image.id}`,
        "POST",
        {},
        { "Content-Type": "application/json" },
        false
      );
      if (response?.success) {
        getDetailsApiCall(parsedInclusionDetails?.packageId);

        // setInclusionDetails((prev) => ({ ...prev, imageMetadata: "" }));
        toast.success(response?.message);
      }
    } catch (error) {
      toast.error("Error deleting file");
    } finally {
      setButtonLoader(false);
    }
  };

  console.log("pp", parsedInclusionDetails, inclusionDetails);

  return loader ? (
    <center style={styles.header}>
      <CircularProgress />
    </center>
  ) : (
    <>
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.headerContent}>
            <LeftArrowIcon
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            />
            <div
              style={{ ...styles.idText, fontSize: "14px", fontWeight: "500" }}
            >
              {project?.name}
            </div>
          </div>
        </header>

        <div style={styles.subContainer}>
          <div style={{ display: "flex" }}>
            <div style={{ ...styles.rowFlex, gap: "15px", flex: "1" }}>
              {/* <Box
                component="img"
                src={getImageSrc(inclusionDetails?.image?.path)}
                alt="Inclusion Icon"
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "16px",
                  marginRight: 1,
                }}
              /> */}
              {parsedInclusionDetails?.image?.path ? (
                <div style={{ position: "relative" }}>
                  <img
                    src={getImageSrc(parsedInclusionDetails?.image?.path)}
                    alt="Inclusion Image"
                    style={{
                      width: "100px",
                      height: "100px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <IconButton
                    onClick={handleDeleteImage}
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      padding: "4px",
                      backgroundColor: "#fafafa",
                      borderRadius: "50%",
                      border: "1px solid red",
                    }}
                  >
                    <CloseIcon style={{ fontSize: "12px", color: "red" }} />
                  </IconButton>
                </div>
              ) : (
                <IconButton
                  component="label"
                  style={{
                    width: "100px",
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    border: "1px dashed #ccc",
                    background: "#fafafa",
                  }}
                >
                  <AddIcon fontSize="small" />
                  <input
                    type="file"
                    hidden
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                </IconButton>
              )}
              <div style={styles.columnFlex}>
                <h2 style={styles.projectHeading}>{inclusionDetails?.name}</h2>
                <p style={styles.endDate}>
                  Last Update:{" "}
                  {project?.updatedAt
                    ? moment(project.updatedAt).format("MMM DD, YYYY hh:mm A")
                    : "N/A"}
                </p>

                <div style={styles.statusContainer}>
                  <div
                    style={{
                      ...styles.milestoneStatusCircle,
                      backgroundColor:
                        statusStyleArray.find(
                          (style) => style.status === inclusionDetails?.status
                        )?.backgroundColor || "transparent",
                    }}
                  ></div>
                  <div style={styles.statusText}>
                    {getStatusDisplayText(inclusionDetails?.status)}
                  </div>
                </div>

                {/* <div
                  style={{
                    ...styles.status_pill,
                    backgroundColor:
                      statusStyleArray.find(
                        (style) => style.status === inclusionDetails?.status
                      )?.backgroundColor || "transparent",
                    color:
                      statusStyleArray.find(
                        (style) => style.status === inclusionDetails?.status
                      )?.color || "black",
                  }}
                >
                  {getStatusDisplayText(inclusionDetails?.status)}
                </div> */}
              </div>
            </div>

            <div style={{ ...styles.columnFlex, flex: "1" }}>
              <p style={styles.idLabel}>Owner</p>
              <p style={styles.price}>
                <Box display="flex" alignItems="center">
                  {project?.owner && (
                    <Box
                      component="img"
                      src={getImageSrc(project?.owner?.profileUrl)}
                      alt="Project Icon"
                      sx={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        boxShadow: "0px 4px 2.67px 0px #00000026",
                        marginRight: 1,
                      }}
                    />
                  )}
                  {project?.owner?.companyName}
                </Box>
              </p>
            </div>
          </div>
        </div>

        <div style={{ ...styles.overview_section, margin: "1vh 2vw 0 2vw" }}>
          <div style={{ ...styles.section_1, ...styles.columnFlex }}>
            <div style={{ ...styles.columnFlex }}>
              <div style={styles.section_heading}>Description</div>
              <h3 style={styles.section_sub_heading}>
                {inclusionDetails?.description}
              </h3>
            </div>
            <div style={{ ...styles.columnFlex, marginTop: "1vh" }}>
              <div style={styles.section_heading}>Specification</div>
              <h3 style={styles.section_sub_heading}>
                {inclusionDetails?.specifications}
              </h3>
            </div>
            <div style={{ ...styles.columnFlex, marginTop: "2vh" }}>
              <VariantCarousel
                details={inclusionDetails}
                getDetailsApiCall={getDetailsApiCall}
                selectedBudget={selectedBudget}
                setSelectedBudget={setSelectedBudget}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InclusionDetails;
